import { connect } from 'react-redux';
import CompetitionsList from './CompetitionsList';
import { COMPETITIONS_ROUTER_NEW, COMPETITIONS_ROUTER_EDIT } from '../constants';
import { push } from 'react-router-redux/lib/actions';
import CRUDActions from '../../../actions/competition';
import {
  listStateFromCRUD,
  listDispatchFromCrud
} from '../../../selectors/crud';
import { setHeaderTitle } from '../../../actions/layout';
import { getCurrentClubId } from '../../../selectors/club-settings';

export default connect(
  state => ({
    headerTitle: 'Competitions',
    ...listStateFromCRUD(state.competition),
    filter: {
      club_id: getCurrentClubId(state)
    }
  }),
  dispatch => ({
    updateHeaderTitle: title => dispatch(setHeaderTitle(title)),
    ...listDispatchFromCrud(dispatch, CRUDActions),
    edit: id => dispatch(push(COMPETITIONS_ROUTER_EDIT.replace(':id', id))),
    add: () => dispatch(push(COMPETITIONS_ROUTER_NEW))
  }),
)(CompetitionsList);



// WEBPACK FOOTER //
// ./src/components/Competitions/CompetitionsList/index.js